import { FC } from 'react'

import { useQueryApi } from 'peach/data/useQueryApi'

import { R } from 'core/helpers'
import { isNotFoundError } from 'core/helpers/error'
import { useGetWorkflowTypeById } from 'core/types'

import ModelLink from './ModelLink'

type WorkflowTypeLinkProps = {
  workflowTypeId: string
}

const WorkflowTypeLink: FC<WorkflowTypeLinkProps> = ({ workflowTypeId }) => {
  const [_, { companyId }] = useQueryApi()
  const { data: workflowType, isLoading } = useGetWorkflowTypeById({
    companyId,
    workflowTypeId,
    options: {
      throwOnError: R.isNot(isNotFoundError),
    },
  })

  const link =
    companyId && `/companies/${companyId}/workflow-types/${workflowTypeId}`

  return (
    <ModelLink
      id={workflowTypeId}
      isLoading={isLoading}
      link={link}
      model={workflowType}
    />
  )
}

export default WorkflowTypeLink
